<scitis-app-global-page-header [pageTitle]="'IoT Connectivity Logs'">
  <ng-template #filterElement>
    <scitis-admin-gateway-log-iot-actions
      (refreshTrigger)="handleRefreshTrigger($event)"
      [disableCSVExportButton]="disableCSVExportButton"
      [disableRefreshButton]="disableRefreshButton"
      [logData]="logData">
    </scitis-admin-gateway-log-iot-actions>
  </ng-template>
</scitis-app-global-page-header>

<div class="card card-table-view mb-3">
  <div class="card-body">
    <div class="table-responsive-md">
      <table class="table table-hover vertical-align-middle mb-0">
        <thead>
          <tr>
            <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="timestamp" style="width: 30%;">
              <span translate>Timestamp</span>
            </th>
            <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="connectionStatus"
              style="width: 40%;">
              <span translate>Connection Status</span>
            </th>
            <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="duration" style="width: 30%;">
              <span translate>Duration</span>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (log of logData; track log) {
            <tr>
              <td [innerText]="log.timestamp | date:'yyyy-MM-dd HH:mm:ss.SSS z'"></td>
              <td [ngClass]="getConnectionStatusClass(log)">
                <span [innerText]="log.connectionStatus"></span>
                @if (isDisconnected(log)) {
                  <span class="text-danger ml-1">
                    <em [ngbTooltip]="connectionStatusTooltip(log)" class="fa-solid fa-circle-exclamation" container="body"></em>
                  </span>
                }
              </td>
              <td [innerText]="msToTime(log.duration)"></td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
